// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CcmCheckboxListHeader {
  margin-bottom: 2px;
}
.CcmCheckboxListHeader .mat-mdc-checkbox .mdc-form-field label {
  font-weight: bold;
}

fi-checkbox-list {
  display: block;
}
fi-checkbox-list fi-checkbox {
  line-height: 2;
}
fi-checkbox-list .mat-mdc-checkbox .mdc-form-field label {
  max-width: 125px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checkbox-list/checkbox-list.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AAAI;EACI,iBAAA;AAER;;AAEA;EACI,cAAA;AACJ;AACI;EACI,cAAA;AACR;AACI;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AACR","sourcesContent":[".CcmCheckboxListHeader {\r\n    margin-bottom: 2px;\r\n    .mat-mdc-checkbox .mdc-form-field label {\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\nfi-checkbox-list {\r\n    display: block;\r\n\r\n    fi-checkbox {\r\n        line-height: 2;\r\n    }\r\n    .mat-mdc-checkbox .mdc-form-field label {\r\n        max-width: 125px;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        display: inline-block;\r\n        white-space: nowrap;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
